/**
 * Sentry — Frontend hata takibi.
 * Boş sayfa, JS hataları, API hataları Sentry'de görünür.
 * DSN yoksa devre dışı kalır.
 */
import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN;
const env = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "production";

if (dsn) {
  const integrations = [Sentry.browserTracingIntegration()];
  if (typeof Sentry.replayIntegration === "function") {
    integrations.push(Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }));
  }
  Sentry.init({
    dsn,
    environment: env,
    integrations,
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 0.5,
    replaysSessionSampleRate: 0,
    ignoreErrors: [
      "ResizeObserver loop",
      "Non-Error promise rejection",
      "ChunkLoadError",
      /Loading chunk \d+ failed/,
    ],
  });
}

export default Sentry;
